var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"opt-out-reason"},[_vm._v(_vm._s(_vm.optedOutReason))])}
var staticRenderFns = []

export { render, staticRenderFns }